/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { tagName } from '@ember-decorators/component';
import { computed } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@ember/component';
import { htmlSafe } from '@ember/template';
import { queryEncode } from 'cio/helpers/query';

export function stringToPrimitiveType(string) {
  try {
    return JSON.parse(string);
  } catch (e) {
    return string;
  }
}

@tagName('')
export default class HelpPopover extends Component {
  @service features;

  customer = null;
  event = null;

  @computed('customer', 'event')
  get liquidPlaygroundLink() {
    let customer = this.get('customer');
    let event = this.get('event');
    let props = {
      isHtmlEnabled: false,
      liquid: '',
      variables: {
        customer: {},
        event: {},
      },
    };

    if (customer) {
      let attrs = customer.get('attrs');

      Object.keys(attrs).forEach((key) => {
        // All customer attributes are stored as strings,
        // coercing them to their primitive types will give
        // us a more correct Liquid Playground JSON context.
        props.variables.customer[key] = stringToPrimitiveType(attrs[key]);
      });
    }

    if (event) {
      props.variables.event = event.get('attrs');
    }

    return htmlSafe(`https://internal.customer.io/liquid-playground/#/?props=${queryEncode(props)}`);
  }
}
